/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BenefitOptionViewModel } from "../types/BenefitOptionViewModel.ts";

export const benefitOptionViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do benefício.")),
  name: z.string().describe("Nome do benefício.").nullish(),
  nationalPlan: z.optional(
    z.boolean().describe("Indica se o benefício se aplica a planos nacionais."),
  ),
  internationalPlan: z.optional(
    z
      .boolean()
      .describe("Indica se o benefício se aplica a planos internacionais."),
  ),
}) as unknown as ToZod<BenefitOptionViewModel>;
